import React, { useState, useEffect } from "react";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import { XCircle, Edit3 } from "react-feather";
import AddTerminal from "./AdminComp/AddTerminal";
import axios from "axios";
import { baseurl } from "../../component/Baseurl"; // Assuming baseurl is set properly
import Swal from "sweetalert2"; // Import SweetAlert2

function AllFlightCode() {
  const [terminalData, setTerminalData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(50);
  const [loading, setLoading] = useState(true); // Loading state

  // Fetch terminal data from the API when the component mounts
  useEffect(() => {
    const fetchTerminalData = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllTerminals`);
        if (response.data.message === "Terminals retrieved successfully") {
          setTerminalData(response.data.data); // Update to use response.data.data
        }
      } catch (error) {
        console.error("Error fetching terminal data:", error);
      } finally {
        setLoading(false); // Set loading to false once data is fetched
      }
    };

    fetchTerminalData();
  }, []);

  // Filter terminal based on the search term
  const filteredTerminals = terminalData.filter(
    (terminal) =>
      terminal.terminal_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      terminal.terminal_code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalRecords = filteredTerminals.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const startIndex = (currentPage - 1) * recordsPerPage;
  const paginatedTerminals = filteredTerminals.slice(
    startIndex,
    startIndex + recordsPerPage
  );

  const handleEdit = (id) => {
    alert(`Edit terminal ID ${id}.`);
  };

  const handleDelete = (id) => {
    // Show SweetAlert2 confirmation dialog
    Swal.fire({
      title: 'Are you sure?',
      text: "This action cannot be undone.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Send delete request to backend API using POST and send ID in the body
          const response = await axios.post(`${baseurl}deleteTerminal/${id}`);

          if (response.status === 200) {
            // Show success alert
            Swal.fire({
              icon: 'success',
              title: 'Deleted!',
              text: 'Terminal has been deleted successfully.',
              showConfirmButton: false,
              timer: 1500,
            });
            // Remove the deleted terminal from the list
            setTerminalData(terminalData.filter(terminal => terminal.id !== id));
          } else {
            // Show error alert if the response is not successful
            Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: response.data.message || 'Failed to delete the terminal.',
            });
          }
        } catch (error) {
          console.error("Error deleting terminal:", error);
          // Show network error alert
          Swal.fire({
            icon: 'error',
            title: 'Network error',
            text: 'Please try again later.',
          });
        }
      }
    });
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const handleRecordsPerPageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <BreadCrumb />
          <div className="container-fluid">
            <div className="crdmain mb-2">
              <div
                className="d-flex justify-content-between align-items-center"
                style={{ width: "100%" }}
              >
                <h2 className="chart-title mb-0">All Terminals</h2>
                <div className="ms-auto">
                  <AddTerminal />
                </div>
              </div>

              <div className="row g-1 mt-0 mb-0 justify-content-end">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="input1"
                    placeholder="Search by name or code"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div className="col-md-1 text-end">
                  <select
                    className="input1"
                    value={recordsPerPage}
                    onChange={handleRecordsPerPageChange}
                  >
                    <option value="50">50</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                  </select>
                </div>
              </div>

              <div className="row g-2 mt-0 mb-0">
                <div className="col-md-12 p-0">
                  <div className="table-responsive classic-table">
                    <table className="table table-striped table-hover">
                      <thead className="table-header">
                        <tr className="text-start">
                          <th>#</th>
                          <th>Terminal Name</th>
                          <th>Code</th>  
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? ( // Show loader while fetching data
                          <tr>
                            <td colSpan="6" className="text-center">
                              <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : totalRecords === 0 ? ( // No records found
                          <tr>
                            <td colSpan="6" className="text-center">
                              No records found.
                            </td>
                          </tr>
                        ) : (
                          paginatedTerminals.map((terminal, index) => (
                            <tr key={terminal.id}>
                              <td>{startIndex + index + 1}</td>
                              <td>{terminal.terminal_name}</td>
                              <td>{terminal.terminal_code}</td> 
                              
                              <td>
                                <span
                                  className="btn2 me-2"
                                  title="Edit"
                                  onClick={() => handleEdit(terminal.id)}
                                >
                                  <Edit3 size={15} />
                                </span>
                                <span
                                  className="btn2"
                                  title="Delete"
                                  onClick={() => handleDelete(terminal.id)}
                                >
                                  <XCircle size={15} />
                                </span>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <nav>
                  <ul className="pagination">
                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        className={`page-item ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                        key={index}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllFlightCode;
